import { PATIENT_WAITING_LIST } from "@/api_framework/api_config";
import { IOrgProviderListResponseData, IOrgProvidersListResponse } from "@/api_framework/api_modals/Org";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback } from "react";
import { useAPIUtils } from "../../useAPIUtils";
import { useConfiguration } from "../../useConfiguration";

AxiosCurlirize(axios, () => {});

export type AtHomeStaffListPayload = {
  bookingDate: string;
  clinicIds: string[];
  serviceIds?: string[];
  cityId?: string;
};

type StaffAPIRequestBody = {
  booking_date: string;
  clinic_ids: string[];
  service_id?: string[];
  city_id?: string;
};

export const useAtHomeStaffListAPI = () => {
  const configuration = useConfiguration();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();

  const execute = useCallback(
    async (payload: AtHomeStaffListPayload): Promise<IOrgProviderListResponseData[]> => {
      const body: StaffAPIRequestBody = {
        booking_date: payload.bookingDate,
        clinic_ids: payload.clinicIds ?? [],
      };

      if (payload.serviceIds && payload.serviceIds.length > 0) {
        body.service_id = payload.serviceIds;
      }
      if (payload.cityId) {
        body.city_id = payload.cityId;
      }

      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: AxiosResponse<IOrgProvidersListResponse> = await axios.post(
          `${PATIENT_WAITING_LIST?.AT_HOME_STAFF_LIST?.baseURL ?? ""}?action=without_rota`,
          body,
          {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          },
        );

        if (response.data.status === true) {
          return response.data.data ?? [];
        }
        return [];
      } catch (error) {
        const axiosError = error as AxiosError;
        captureError(axiosError);
        sendCurl((axiosError.config as any)?.curlCommand);
        return [];
      }
    },
    [captureError, configuration.localStorage.ACCESS_TOKEN.key, sendCurl],
  );

  return execute;
};
